import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, App, Loading, LoadingController, Events, Toast } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from '../pages/login/login';
import { OauthService } from '../shared/services/oauth.service';
import { BeneficiaireListPage } from '../pages/beneficiaire-list/beneficiaire-list';
import { Config } from '../shared/services/config.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../shared/services/user.service';
import { ToastDirective } from '../shared/directives/toast/toast';
import {LoadingService} from "../shared/services/loading.service";
import { CeService } from "../shared/services/ce.service";
import { EnvironnementInitializer } from "../core/app/environnement-initializer.service";
import { MenuService } from '../shared/services/menu.service';
import {UpdateAppService} from "../shared/services/update-app.service";
import {PlatformContextService} from "../shared";

@Component({
  templateUrl: 'app.html'
})
export class EkipeaApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any;
  pages: Array<{ title: string; component: any }>;
  public currentMode;
  public loader: Loading;
  public isLoading: boolean;
  public userIsLogged: boolean = false;
  public verifVersion: boolean = false;

  constructor(
    private platform: Platform,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private oauthService: OauthService,
    public events: Events,
    private loadingCtrl: LoadingController,
    private loadingService: LoadingService,
    public app: App,
    public readonly config: Config,
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private toast: ToastDirective,
    private ceService: CeService,
    private environnementInitializer: EnvironnementInitializer,
    private readonly menuService: MenuService,
    private updateAppService: UpdateAppService,
    public platformContextService: PlatformContextService,
  ) {
    this.currentMode = config.getConfig('app');
    this.pages = [
      {title: 'Accueil', component: EkipeaApp},
      {title: 'Login', component: LoginPage}
    ];

    this.initializeApp();

    if (this.oauthService.userIsLoggedIn()) {
      this.rootPage = BeneficiaireListPage;
    } else {
      this.rootPage = LoginPage;
    }

    this.environnementInitializer.isSupported();

    if (this.oauthService.userIsLoggedIn()) {
      this.userService.getTokenExpired().subscribe(response => {
        // Si la date d'expiration est dépassé, ou s'il reste moins d'une heure
        if (response !== null && response.data === true) {
          this.toast.createAdv({message: response.message, type: 'success'});
          this.oauthService.logOut(this.app);
        }
      }, error =>  {
        this.oauthService.logOut(this.app);
      });
    }

  }

  processLoading(loading: boolean, customText?: string) {
    let safeSvg: any = `<div class="custom-loader"><svg width="160" height="160" viewBox="0 0 200 200">
        <defs>
        <linearGradient id="gradient">
        <stop offset="0%" stop-color="#B12634"></stop><stop offset="100%" stop-color="#F2A401"></stop>
        </linearGradient>
        </defs>
        <path d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0" stroke="url(#gradient)"/>
        </svg>` + (customText ?  (`<span style="text-transform: none">` + customText + `</span>`) : `<span>Chargement<br><strong>en cours</strong></span>`) + `</div>`;
    safeSvg = this.sanitizer.bypassSecurityTrustHtml(safeSvg);
    if (loading && !this.isLoading) {
      this.loader = this.loadingCtrl.create({
        spinner: 'hide',
        content: safeSvg,
        dismissOnPageChange: false
      });
      this.loader.present();
      this.isLoading = true;
      this.loader.onDidDismiss(() => {
        this.isLoading = null;
      });
    } else if (this.isLoading) {
      this.loader.dismiss().catch(() => {
      });
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      // On fait en sorte que la barre de statut ne passe pas sur l'appli
      this.statusBar.overlaysWebView(false);
      this.statusBar.styleLightContent();
      this.statusBar.backgroundColorByHexString('#7e0514');

      this.splashScreen.hide();


      // Chaque navigation
      this.app.viewDidEnter.subscribe(
        (e) => {
          // Vérifie la version à l'ouverture de chaque page/composant
          // Ne vérifie la version que sur l'ouverture des pages (ViewComponent), pas sur les toasts ou loading
          // Pour information, Toast et Loading sont des ViewComponent spécifiques
          if (!(e instanceof Loading) && !(e instanceof Toast)) {
            if (this.oauthService.userIsLoggedIn()) {
              this.userService.getAccess().subscribe(response => {
                if (response !== null) {
                  if (response === 'invalid version') {
                    this.updateAppService.launchStore('v1');
                  } else {
                    this.toast.create(response);
                    this.oauthService.logOut(this.app);
                  }
                }
              });
              if (!this.verifVersion) {
                this.verifVersion = true;
                if ((<any>window).cordova) {
                  if (this.platformContextService.isSalarie()) {
                    this.ceService.getDetail().subscribe(() => {
                      if (!this.ceService.detail.data.paramCe.accesApplicationV1 && this.ceService.detail.data.paramCe.accesApplicationV2) {
                        const message =
                          'Votre CSE a déployé la nouvelle génération de votre Application mobile.\r\n\r\n' +
                          'De Pocket\'CE vous allez passer à Pocket\'CSE ! avec une ergonomie et une expérience totalement revue.\r\n\r\n' +
                          'Charge à vous de télécharger cette nouvelle APP (quand vous fermerez cet écran vous serez redirigé sur le store) et de vous reconnecter.' +
                          'Pas le choix, c\'est une nouvelle application et il faudra donc vous reconnecter au moins une fois ; mais votre login et mot de passe n\'ont pas changé.' +
                          'En cas d\'oubli, il vous faudra le réinitialiser en cliquant sur "Mot de passe oublié" et suivre la procédure comme lors de votre première connexion.\r\n\r\n' +
                          'Bonne découverte et navigation dans PocKet\'CSE !';
                        this.toast.createAdv({message: message, type: 'error', closeButtonText: 'OK'});
                        this.toast.closeEvent.subscribe(() => {
                          this.updateAppService.launchStore('v2');
                          this.oauthService.logOut(this.app);
                        });
                      } else if (this.ceService.detail.data.paramCe.accesApplicationV1 && this.ceService.detail.data.paramCe.accesCohabitation) {
                        const message =
                          'Votre CSE a déployé la nouvelle génération de votre Application mobile.\r\n\r\n' +
                          'De Pocket\'CE vous allez passer à Pocket\'CSE ! avec une ergonomie et une expérience totalement revue.\r\n\r\n' +
                          'Nous vous invitons à télécharger cette nouvelle APP pour en profiter dès maitenant, même si votre application actuelle reste utilisable encore quelque temps.\r\n' +
                          'Il faudra vous reconnecter au moins une fois car, comme vous le verrez c\'est une toute nouvelle APP ! Votre login et mot de passe n\'ont pas changé. En cas d\'oubli, il vous faudra le réinitialiser en cliquant sur "Mot de passe oublié" et suivre la procédure comme lors de votre première connexion.\r\n\r\n' +
                          '** Conseil ** : installez PocketCSE assez vite avant que votre application actuelle ne soit définitivement fermée.\r\n\r\n' +
                          'Bonne découverte et navigation dans PocKet\'CSE !';
                        this.toast.createAdv({message: message, type: 'error'});
                      }
                    });
                  }
                }
              }
              this.userIsLogged = this.oauthService.userIsLoggedIn();
            }
          }
        }
      );

      this.events.subscribe('loading', (event) => {
        this.processLoading(event.state, event.customText);

      });

      this.app.viewWillLeave.subscribe(
        (e) => {
          if (e.name.indexOf('Page') !== -1) {
            this.processLoading(true);
          }
        }
      );

      if ((<any>window).cordova && (this.platform.is('android') || this.platform.is('ios'))) {
        window.open = (<any>window).cordova.InAppBrowser.open;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts